import React, { useEffect, useState } from "react";
import { STRING_NOT_NULL_HELPER } from "../../common/helpersTxt";
import { validateString, validateValue } from "../../common/validators";
import ModalHeader from "../modals/modalHeader";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MoneyInput from "../Inputs/MoneyInput";
import { Divider } from "@mui/material";
import LoadingBox from "../indicators/LoadingBox";

const ModalRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  border: "none",
  borderRadius: 12,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "95%",
    borderRadius: 0,
    overflow: "auto",
  },
  [theme.breakpoints.up("md")]: {
    width: "30%",
  },
  backgroundColor: "#fff",
  padding: "0 24px 24px",
  "&:focus-visible": {
    border: "none",
  },
}));

export default function CreateOrEditDeliveryRadiusModal({
  isMerchant = false,
  show,
  deliveryRadius,
  closeModal,
  createDeliveryRadius,
  editDeliveryRadius,
}) {
  const [loading, setLoading] = useState(false);
  const [radii, setRadii] = useState(
    deliveryRadius ? deliveryRadius.to_distance / 1000 : 0
  );
  const [isRadiiValid, setIsRadiiValid] = useState(false);
  const [deliveryRadiusDeliveryTax, setDeliveryRadiusDeliveryTax] = useState(
    deliveryRadius ? deliveryRadius.delivery_tax : null
  );
  const [deliveryRadiusDeliveryGuyTax, setDeliveryRadiusDeliveryGuyTax] =
    useState(deliveryRadius ? deliveryRadius.delivery_guy_tax : null);
  const [submitted, setSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (deliveryRadius) {
      setIsEditing(true);
    }
  }, [deliveryRadius]);

  const handleSubmit = () => {
    setLoading(true);
    setSubmitted(true);

    console.log("radii", radii);
    console.log("deliveryRadiusDeliveryTax", deliveryRadiusDeliveryTax);

    const isValid =
      validateString(radii) ||
      validateValue(radii) ||
      validateString(deliveryRadiusDeliveryTax);
    if (!isValid) {
      setIsRadiiValid(false);
      return;
    }

    const deliveryRadiusObj = {
      to_distance: Math.round(radii * 1000),
      delivery_tax: deliveryRadiusDeliveryTax,
      delivery_guy_tax: isMerchant ? null : deliveryRadiusDeliveryGuyTax,
    };

    if (isEditing) {
      editDeliveryRadius({ id: deliveryRadius.id, ...deliveryRadiusObj });
    } else {
      createDeliveryRadius(deliveryRadiusObj);
    }
  };

  if (loading) {
    return <LoadingBox height={100} />;
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={closeModal}
      closeAfterTransition
      sx={{ zIndex: 5000 }}
    >
      <Fade in={show}>
        <ModalRoot>
          <ModalHeader
            label="Raio de Entrega"
            margin={0}
            onClose={closeModal}
          />
          <Box sx={{ padding: 2 }}>
            <TextField
              type="number"
              size="small"
              variant="outlined"
              id="new_deliveryRadius_radii"
              name="deliveryRadius_radii"
              label="Raio de Entrega (km)"
              required
              error={!isRadiiValid && submitted}
              value={radii}
              helperText={
                !isRadiiValid && submitted ? STRING_NOT_NULL_HELPER : ""
              }
              onChange={(event) => {
                setRadii(event.target.value);
                setIsRadiiValid(validateString(event.target.value));
              }}
              inputProps={{ step: "any", min: 0 }}
              fullWidth
            />
          </Box>

          <Divider sx={{ my: 2 }} />
          <Box
            display="flex"
            justifyContent={isMerchant ? "center" : "space-between"}
          >
            <Box>
              <Typography variant="subtitle2" align="center">
                Taxa de Entrega
              </Typography>
              <Box display="flex" justifyContent="center">
                <MoneyInput
                  value={parseFloat(deliveryRadiusDeliveryTax)}
                  setValue={setDeliveryRadiusDeliveryTax}
                />
              </Box>
            </Box>

            {!isMerchant && (
              <Box>
                <Typography variant="subtitle2" align="center">
                  Taxa Entregador
                </Typography>
                <Box display="flex" justifyContent="center">
                  <MoneyInput
                    value={parseFloat(deliveryRadiusDeliveryGuyTax)}
                    setValue={setDeliveryRadiusDeliveryGuyTax}
                  />
                </Box>
              </Box>
            )}
          </Box>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{ mt: 4 }}
          >
            {isEditing ? "Atualizar" : "Cadastrar"}
          </Button>
        </ModalRoot>
      </Fade>
    </Modal>
  );
}
